import colors from 'Application/theme/colors';
import styled from 'styled-components/macro';
import BasePill from './BasePill';

const DisabledPill = styled(BasePill)`
	background-color: ${colors.grey.light};
`;

export default DisabledPill;
